import React from "react";
import ConfigService from "../../../services/configuracion/ConfigService";

function ocultar(){
    let muestraEntrust = false;
    // let muestraOtp=false;
    const tokenActivo = sessionStorage.getItem('tieneToken');

    tokenActivo === "S" && ConfigService.ocultarSegunNombre("serviciosEntrust") === null ? 
    muestraEntrust=true : muestraEntrust=false;

    // ConfigService.ocultarSegunNombre("ServiciosOtp") === null ? 
    // muestraOtp = true : muestraOtp = false;

    return !muestraEntrust ?
    {display:"none"} : null; 
}

function App(props) {
    return (
        <div className="row">
            <div className="steps clearfix" style={{ marginBottom: 5 }}>
            <ul role="tablist">
                <li role="tab" className={props.tittle1}>
                    <span>
                        <div className="title">
                        <span className="title_text current">{props.nombre}</span>

                        </div>
                    </span>
                </li>
                <li role="tab" className={props.tittle2}>
                    <span>
                        <div className="title">
                        <span className="title_text">Consulta</span>
                        </div>
                    </span>
                </li>
                <li role="tab" className={props.tittle3}>
                    <span>
                        <div className="title">
                        <span className="title_text">Cuenta</span>
                        </div>
                    </span>
                </li>
                <li role="tab" className={props.tittle4} style={ocultar()}>
                    <span>
                        <div className="title">
                        <span className="title_text">Código de confirmación</span>
                        </div>
                    </span>
                </li>
                <li role="tab" className={props.tittle5}>
                    <span>
                        <div className="title">
                        <span className="title_text">Verificación</span>
                        </div>
                    </span>
                </li>
                <li role="tab" className={props.tittle6}>
                    <span>
                        <div className="title">
                        <span className="title_text">Confirmación</span>
                        </div>
                    </span>
                </li>
            </ul>
            </div>
        </div>
    ) 
  }
   
  export default App;